var map = {
	"./auth.json": 95111,
	"./common.json": 41761,
	"./customer.json": 30335,
	"./error.json": 50238,
	"./finance.json": 72405,
	"./paymentTerm.json": 55736,
	"./person.json": 95920,
	"./pricelist.json": 15976,
	"./product.json": 6071,
	"./saleOrder.json": 45501,
	"./settings.json": 25051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56972;